import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1297ec48"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "input-flex-container" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "row-break" }, null, -1));
const _hoisted_3 = ["data-external"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InputSetLabel = _resolveComponent("InputSetLabel");
    const _component_InputSetField = _resolveComponent("InputSetField");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputSet, (input, inputIndex) => {
            return (_openBlock(), _createElementBlock("div", {
                key: input.id + 'label',
                style: _normalizeStyle(_ctx.getInputStyle(input)),
                class: _normalizeClass(['input-label-container', 'label' + inputIndex])
            }, [
                _createVNode(_component_InputSetLabel, {
                    input: input,
                    "merge-values": _ctx.mergeValues,
                    fields: _ctx.fields,
                    editable: _ctx.getIsEditable(input)
                }, null, 8, ["input", "merge-values", "fields", "editable"])
            ], 6));
        }), 128)),
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputSet, (input, inputIndex) => {
            return (_openBlock(), _createElementBlock("div", {
                key: input.id + 'input',
                style: _normalizeStyle(_ctx.getInputStyle(input)),
                class: _normalizeClass([['input' + inputIndex], "input-with-help"]),
                "data-external": `view-form-input-${inputIndex}`
            }, [
                _createVNode(_component_InputSetField, {
                    input: input,
                    "merge-values": _ctx.mergeValues,
                    fields: _ctx.fields,
                    "failed-input-updates": _ctx.failedInputUpdates,
                    "recipient-input": _ctx.recipientInput,
                    recipient: _ctx.recipient,
                    sender: _ctx.sender,
                    context: _ctx.context,
                    editable: _ctx.getIsEditable(input),
                    "has-focus": _ctx.hasFocus(input),
                    "updating-inputs": _ctx.updatingInputs,
                    "is-pdf-viewer": _ctx.isPdfViewer,
                    onUpdateValue: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update-value', $event)))
                }, null, 8, ["input", "merge-values", "fields", "failed-input-updates", "recipient-input", "recipient", "sender", "context", "editable", "has-focus", "updating-inputs", "is-pdf-viewer"])
            ], 14, _hoisted_3));
        }), 128))
    ]));
}
